import { Alert, Skeleton } from 'antd';
import { useAffectedInstancesForSizes } from 'hooks/capacityManagementQueries';

const MAX_LISTED_CLUSTERS = 8;

// The clusters running a size on the given operators, checked for all of them at once.
function AffectedClusters({
  sizeIDs,
  sizeName,
}: Readonly<{ sizeIDs: number[]; sizeName: string }>) {
  const queries = useAffectedInstancesForSizes(sizeIDs);
  const isLoading = queries.some(query => query.isLoading);
  const clusters = Array.from(
    new Set(
      queries.flatMap(
        query => query.data?.instances?.map(instance => instance.name) ?? [],
      ),
    ),
  );

  return (
    <section className="capacity-drawer__section">
      <h3 className="capacity-drawer__heading">Affected clusters</h3>
      {isLoading && <Skeleton active title={false} paragraph={{ rows: 2 }} />}
      {!isLoading && clusters.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message={`${clusters.length} cluster${
            clusters.length === 1 ? ' uses' : 's use'
          } ${sizeName} on ${sizeIDs.length === 1 ? 'this operator' : 'these operators'}`}
          description={
            clusters.slice(0, MAX_LISTED_CLUSTERS).join(', ') +
            (clusters.length > MAX_LISTED_CLUSTERS
              ? ` and ${clusters.length - MAX_LISTED_CLUSTERS} more`
              : '')
          }
        />
      )}
      {!isLoading && clusters.length === 0 && (
        <p className="capacity-drawer__muted">
          No clusters use {sizeName} on{' '}
          {sizeIDs.length === 1 ? 'this operator' : 'these operators'}.
        </p>
      )}
    </section>
  );
}

export default AffectedClusters;
